export default __webpack_public_path__ + "static/media/032-nodejs.31d93e46.svg";